<template>
  <div id="overlay">
    <div id="content" class="z-10 flex justify-around w-10/12 mt-20 bg-theme-white rounded-md drop-shadow-lg relative">
      <button
        class="border border-bd-gray rounded drop-shadow-lg absolute right-2 top-2 hover:border-bd-orange transition uration-300"
        @click="$emit('close')">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:text-txt-orange transition uration-300" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div v-show="img_flag === 0" class="w-325 py-8">
        <img :src="img_path + state.cassette_img01" class="">
      </div>
      <div v-show="img_flag === 1" class="w-325 py-8">
        <img :src="img_path + state.cassette_img02" class="">
      </div>
      <div v-show="img_flag === 2" class="w-325 py-8">
        <img :src="img_path + state.cassette_img03" class="">
      </div>
      <div v-show="img_flag === 3" class="w-325 py-8">
        <img :src="img_path + state.cassette_img04" class="">
      </div>
      <div class="p-10">
        <p class="text-lg text-txt-gray">{{ state.cassette_block_name }}</p>
        <p class="text-sm text-txt-gray">メーカー：{{ state.maker_name }}</p>
        <!--<p class="text-base text-txt-gray pt-4">商品コード：{{state.ichioshi_product_code}}</p>-->
        <!--<p class="text-base text-txt-gray pt-1 pb-4">型番：{{state.Product_number}}</p>-->
        <div class="flex pt-4">
          <article class="w-16 h-16 m-1">
            <img v-if="state.cassette_img01 === ' ' || state.cassette_img01 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_01" :src="img_path + state.cassette_img01">
          </article>
          <article class="w-16 h-16 m-1">
            <img v-if="state.cassette_img02 === ' ' || state.cassette_img02 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_02" :src="img_path + state.cassette_img02">
          </article>
          <article class="w-16 h-16 m-1">
            <img v-if="state.cassette_img03 === ' ' || state.cassette_img03 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_03" :src="img_path + state.cassette_img03">
          </article>
          <article class="w-16 h-16 m-1">
            <img v-if="state.cassette_img04 === ' ' || state.cassette_img04 === ''" class="hidden">
            <img v-else
              class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
              @click="clk_img_04" :src="img_path + state.cassette_img04">
          </article>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watchEffect, reactive } from 'vue';
import { useRoute } from 'vue-router'
import axios from 'axios'
import { search_json } from '@/json.config.js';

export default {
  name: 'Modal',
  props: {
    flag: Number
  },
  setup(props) {
    // console.log(props)
    const route = useRoute()
    // const category_param = ref(route.query.webcat_view)
    let group_id = ref('')
    // const cassette_block_id = ref('')
    // let url = ref('')
    const img_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/";

    // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search.json"

    const img_flag = ref()
    watchEffect(() => {
      const checkFlag = () => {
        switch (props.flag) {
          case 0:
            img_flag.value = 0;
            break
          case 1:
            img_flag.value = 1;
            break
          case 2:
            img_flag.value = 2;
            break
          case 3:
            img_flag.value = 3;
            break
        }
      }
      checkFlag()
      // console.log(img_flag)
    })

    const state = reactive({
      data: null,
      items: null,
      cassette_block: null,
      product_name: null,
      maker_name: null,
      cassette_img01: null,
      cassette_img02: null,
      cassette_img03: null,
      cassette_img04: null
    })

    watchEffect(() => {
      group_id = ref(route.query.cassette_id)
      // url = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=product&webcat_view="+category_param.value+"&cassette_id="+group_id.value;

      const modal_data = ref([])
      async function getitems() {

        // console.log("img01");
        // console.log(state);


        const all_data = await axios.get(search_json)
        modal_data.value = []
        all_data.data.forEach(function (value) {
          if (value.cassette_id === group_id.value) {
            // console.log(value.group_id)
            modal_data.value.push(value)
          }
        })

        // state.data = await axios.get(url)
        // state.data = modal_data.value
        // state.items = state.data.data.Items
        state.items = modal_data.value
        state.cassette_id = state.items[0].cassette_id
        state.webcat_view = state.items[0].webcat_view
        state.cassette_block_name = state.items[0].cassette_block_name
        state.product_name = state.items[0].product_name;
        state.maker_name = state.items[0].maker_name;
        state.cassette_comment01 = state.items[0].cassette_comment01;
        state.cassette_comment02 = state.items[0].cassette_comment02;
        state.cassette_comment03 = state.items[0].cassette_comment03;
        state.cassette_img01 = state.items[0].cassette_img01;
        state.cassette_img02 = state.items[0].cassette_img02;
        state.cassette_img03 = state.items[0].cassette_img03;
        state.cassette_img04 = state.items[0].cassette_img04;
        state.maker_name = state.items[0].maker_name;


        // console.log(modal_data.value)
      }
      getitems()
    })

    const clk_img_01 = () => {
      img_flag.value = 0
    }
    const clk_img_02 = () => {
      img_flag.value = 1
    }
    const clk_img_03 = () => {
      img_flag.value = 2
    }
    const clk_img_04 = () => {
      img_flag.value = 3
    }

    return {
      img_path,
      img_flag,
      state,
      // getItem,
      clk_img_01,
      clk_img_02,
      clk_img_03,
      clk_img_04
    }

  }

}
</script>

<style>
#overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
